import { memoizeFn } from './_cache'
import store from '../state/_store'

export const sortPageIds = (arr, field) => {
  // Function to compare two items based on the provided field and dateTime if necessary
  const compare = (a, b) => {
    if (field === 'score') {
      if (a[field] > b[field]) return -1
      if (a[field] < b[field]) return 1
    } else {
      if (a[field] > b[field]) return 1
      if (a[field] < b[field]) return -1
    }

    // If sorting by score and scores are equal, also sort by dateTime
    if (field === 'score' && a[field] === b[field]) {
      if (new Date(a.dateTime) < new Date(b.dateTime)) return -1
      if (new Date(a.dateTime) > new Date(b.dateTime)) return 1
    }
    return 0
  }

  // Sort the array using the compare function
  return arr.sort(compare)
}

export const fetchResults = async (requestBody, token) => {
  const url = store.urls('search')

  try {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    }
    const response = await fetch(url, requestOptions)

    if (!response.ok) {
      console.error('Network response invalid')
      return []
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error('There was a problem with your fetch operation:', error)
  }
}

export const getResults = async (requestBody, token) => {
  if (!Object.keys(requestBody).length) {
    return
  }

  const cachedFetchResults = memoizeFn(fetchResults)
  const response = await cachedFetchResults(requestBody, token)
  return response
}

export const getFilterValues = (container) => {
  const filters = {}
  const radioValues = container.querySelectorAll('.filter__items-wrapper :checked')

  radioValues.forEach((radio) => {
    filters[radio.name] = radio.value
  })

  return filters
}

export const showLoader = (container) => {
  const loading = container.querySelector('.loading')
  loading.style.display = 'grid'

  const searchResultsWrapper = container.querySelector('.results')
  const queryMeta = container.querySelector('.query__meta')
  const pagination = container.querySelector('.pagination')

  searchResultsWrapper.style.display = 'none'
  queryMeta.style.display = 'none'
  pagination.classList.add('pagination--hide')
}

export const hideLoader = (container) => {
  const loading = container.querySelector('.loading')
  const searchResultsWrapper = container.querySelector('.results')
  const queryMeta = container.querySelector('.query__meta')

  loading.style.display = 'none'
  searchResultsWrapper.style.display = 'block'
  queryMeta.style.display = 'inline'

  if (store.totalPages() > 1) {
    const pagination = container.querySelector('.pagination')
    pagination.classList.remove('pagination--hide')
  }
}

export const noResults = (container) => {
  const loading = container.querySelector('.loading')
  loading.style.display = 'none'

  const results = container.querySelector('.results')
  if (results) {
    const noResultsText = results.dataset.noresults

    results.style.display = 'block'
    results.innerText = noResultsText
  }
}
